/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
import { Box, Grid } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";
import DropDownSelect from "../../../../components/DropDownSelect/DropDownSelect";
import { SERVICES } from "../../../../components/Layout/Services";
import { SERVICES as MasterDataServices } from "../../../../components/Layout/Services/MasterDataServices";
import { get } from "../../../../components/Layout/ApiHandler/apihandler";
import InputField from "../../../../components/Layout/fieldInput/InputField";
import AutoCompleteDropdown from "../../../../components/Layout/AutoCompleteDropdown/AutoCompleteDropdown";

function AdvancedSearch({
  clearValues,
  onAmountChange,
  onOrderIdChange,
  onDataEnterdBy,
  setAdvancedSearchValues,
  amountValue,
  orderIdValue,
  updateSortingMethod,
}) {
  const [payableCity, setPayableCity] = useState([]);
  const [selectedPayableCity, setSelectedPayableCity] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState([]);
  const [paymentGateway, setPaymentGateway] = useState([]);
  const [selectedPaymentGateway, setSelectedPaymentGateway] = useState([]);
  const [receiptType, setReceiptType] = useState([]);
  const [selectedReceiptType, setSelectedReceiptType] = useState([]);
  const [uinType, setUinType] = useState([]);
  const [selectedUinType, setSelectedUinType] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [newSelectedData, setNewSelectedData] = useState("");
  const [profileData, setProfileData] = useState({});
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const sortFields = [
    { value: "fullName", label: "Name" },
    { value: "orderId", label: "Order ID" },
    { value: "updatedAt", label: "Contribution Date" },
  ];

  const sortOrders = [
    { value: "ASC", label: "Ascending" },
    { value: "DESC", label: "Descending" },
  ];
  const [selectedSortField, setSelectedSortField] = useState("");
  const [selectedSortOrder, setSelectedSortOrder] = useState("");

  const getUserRole = async () => {
    try {
      const url = `${SERVICES.GET_PROFILE}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setProfileData(data.data);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handlePaymentMethod = async () => {
    try {
      const url = `${MasterDataServices.GET_PAYMENT_METHODS}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        const paymentMethodVal = data.data.map((d) => ({
          entityTitle: d.name,
          value: d.name,
        }));
        setPaymentMethods(paymentMethodVal);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handlePayableCity = async () => {
    try {
      const url = `${MasterDataServices.GET_PAYABLE_CITIES}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        const payableFormattedPos = data.data.map((d) => ({
          entityTitle: d.cityName,
          value: d.cityName,
        }));
        setPayableCity(payableFormattedPos);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handlePaymentGateway = async () => {
    try {
      const url = `${MasterDataServices.GET_PAYMENT_GATEWAYS}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        const paymentGatewayVal = data.data.map((d) => ({
          entityTitle: d.name,
          value: d.name,
        }));
        setPaymentGateway(paymentGatewayVal);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handleReceiptType = async () => {
    try {
      const url = `${SERVICES.RECEIPT_TYPES}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        const receiptTypesVal = data.data.receiptTypes.map((d) => ({
          entityTitle: d.name,
          value: d.name,
        }));
        setReceiptType(receiptTypesVal);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handleUinType = async () => {
    try {
      const url = `${MasterDataServices.GET_UIN_TYPES}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        const uinTypeVal = data.data.map((d) => ({
          entityTitle: d.name,
          value: d.name,
        }));
        setUinType(uinTypeVal);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  useEffect(() => {
    handlePaymentMethod();
    handlePayableCity();
    handlePaymentGateway();
    handleReceiptType();
    handleUinType();
  }, []);
  useEffect(() => {
    setAdvancedSearchValues((prevValues) => ({
      ...prevValues,
      selectedPayableCity,
      selectedPaymentMethod,
      selectedPaymentGateway,
      selectedReceiptType,
      selectedUinType,
      newSelectedData,
    }));
  }, [
    selectedPayableCity,
    selectedPaymentMethod,
    selectedPaymentGateway,
    selectedUinType,
    selectedReceiptType,
    newSelectedData,
  ]);
  useEffect(() => {
    getUserRole();
  }, []);
  useEffect(() => {
    if (clearValues) {
      setSelectedPaymentGateway([]);
      setSelectedPaymentMethod([]);
      setSelectedUinType([]);
      setSelectedReceiptType([]);
    }
  }, [clearValues]);

  useEffect(() => {
    const sortOrder = selectedSortOrder || "ASC";
    updateSortingMethod(`${selectedSortField},${sortOrder}`);
  }, [selectedSortField, selectedSortOrder]);

  useEffect(() => {
    if (queryParams.get("paymentGatewayTypes") === null) {
      setSelectedPaymentGateway([]);
    }
    if (queryParams.get("paymentMethodTypes") === null) {
      setSelectedPaymentMethod([]);
    }
    if (queryParams.get("uinTypes") === null) {
      setSelectedUinType([]);
    }
    if (queryParams.get("receiptType") === null) {
      setSelectedReceiptType([]);
    }
  }, [
    queryParams.get("paymentGatewayTypes"),
    queryParams.get("paymentMethodTypes"),
    queryParams.get("uinTypes"),
    queryParams.get("receiptType"),
  ]);
  return (
    <Box sx={{ width: "100%" }}>
      <Grid container rowSpacing={4} columnSpacing={5}>
        <Grid item xs={6}>
          <DropDownSelect
            title="Payment Gateway"
            multiple
            selectOptions={paymentGateway}
            value={selectedPaymentGateway}
            setValue={setSelectedPaymentGateway}
            style={{ maxWidth: 290 }}
            className="dropdown-multiple"
          />
        </Grid>
        <Grid item xs={6} />
        <Grid item xs={6}>
          <InputField
            label="Order Id"
            name="orderId"
            value={orderIdValue}
            onChange={(event) => {
              const { value } = event.target;
              onOrderIdChange(value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <InputField
            label="Amount"
            name="amount"
            value={amountValue}
            onChange={(event) => {
              const { value } = event.target;
              onAmountChange(value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <DropDownSelect
            title="UIN Type"
            multiple
            selectOptions={uinType}
            value={selectedUinType}
            setValue={setSelectedUinType}
            style={{ maxWidth: 290 }}
            className="dropdown-multiple"
          />
        </Grid>
        <Grid item xs={6}>
          <DropDownSelect
            title="Receipt Type"
            multiple
            selectOptions={receiptType}
            value={selectedReceiptType}
            setValue={setSelectedReceiptType}
            style={{ maxWidth: 290 }}
            className="dropdown-multiple"
          />
        </Grid>
        <Grid item xs={6}>
          <AutoCompleteDropdown
            options={sortFields.map((field) => ({
              value: field.value,
              label: field.label,
            }))}
            label="Sort Field"
            value={selectedSortField}
            onChange={(selectedValue) => {
              setSelectedSortField(selectedValue?.value);
            }}
            inputProps={{ required: false }}
            useHiddenInput
          />
        </Grid>
        <Grid item xs={6}>
          <AutoCompleteDropdown
            options={sortOrders.map((order) => ({
              value: order.value,
              label: order.label,
            }))}
            label="Sort Order"
            value={selectedSortOrder}
            onChange={(selectedValue) => {
              setSelectedSortOrder(selectedValue?.value);
            }}
            inputProps={{ required: false }}
            useHiddenInput
          />
        </Grid>
      </Grid>
    </Box>
  );
}
export default AdvancedSearch;

// If we want to use AutoComplete Dropdown use commented Code otherwise use the above code
